// Lista de capitales de los departamentos de Peru, con "Remoto" como primera opcion
const ciudadesPeru = [
  "Servicio Remoto",
  "Amazonas",
  "Ancash",
  "Chimbote (Puerto)",
  "Apurimac",
  "Arequipa",
  "Matarani (Puerto)",
  "Ayacucho",
  "Cajamarca",
  "Callao",
  "Cusco",
  "Huancavelica",
  "Huanuco",
  "Ica",
  "Pisco (Puerto)",
  "Junin",
  "La Libertad",
  "Salaverry (Puerto)",
  "Lambayeque",
  "Lima",
  "Callao (Puerto)",
  "Chancay (Puerto)",
  "Loreto",
  "Madre de Dios",
  "Moquegua",
  "Ilo (Puerto)",
  "Pasco",
  "Piura",
  "Paita (Puerto)",
  "Puno",
  "San Martin",
  "Tacna",
  "Tumbes",
  "Ucayali",
];

export { ciudadesPeru };
